import { createContext, useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { defaultLocale, type Locale } from './config';

interface LocaleContextType {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

const LocaleContext = createContext<LocaleContextType>({
  locale: defaultLocale,
  setLocale: () => {},
});

export function useLocale() {
  return useContext(LocaleContext);
}

export function I18nProvider({ children }: { children: React.ReactNode }) {
  const { i18n } = useTranslation();

  const setLocale = useCallback((newLocale: Locale) => {
    localStorage.setItem('fyso-locale', newLocale);
    i18n.changeLanguage(newLocale);
    document.documentElement.lang = newLocale;
  }, [i18n]);

  return (
    <LocaleContext.Provider value={{ locale: i18n.language as Locale, setLocale }}>
      {children}
    </LocaleContext.Provider>
  );
}
